/**
 * Build Progress Types
 *
 * Types for tracking and displaying build progress in the planning UI.
 */
/** Status arrays for type-safe filtering */
export const IN_PROGRESS_STATUSES = ['building', 'queued', 'paused', 'initializing'];
export const COMPLETED_STATUSES = ['completed', 'failed', 'cancelled'];
